import {
  Mapping,
  RelationshipMapping,
} from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import {
  isMapping,
  isRelationshipMapping,
} from 'src/containers/ProjectDiagram/utils/data';
import { removeMapping } from 'src/containers/ProjectDiagram/utils/mapping/removeMapping';
import { removeRelationshipMapping } from 'src/containers/ProjectDiagram/utils/mapping/removeRelationshipMapping';
import { getModelConceptClassValue } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';

export const removeMappingsForNode = (key: string) => (model: Model) => {
  const mappingLinks = model.linkDataArray.filter(
    (linkData): linkData is Mapping =>
      isMapping(linkData) && linkData.to === key
  );
  mappingLinks.forEach((linkData) => removeMapping(linkData)(model));

  const relationshipMappingLinks = model.linkDataArray.filter(
    (linkData): linkData is RelationshipMapping =>
      isRelationshipMapping(linkData) &&
      (linkData.fromClassIri === getModelConceptClassValue(key) ||
        linkData.toClassIri === getModelConceptClassValue(key))
  );
  relationshipMappingLinks.forEach((linkData) =>
    removeRelationshipMapping(linkData)(model)
  );
};
